import React from "react";
import { NavLink } from "react-router-dom";

const Logo = () => {
	return (
		<NavLink to="/" className=" text-xl">
			MovieScreen
		</NavLink>
	);
};

export default Logo;
